<div *ngIf="!isLoading" class="margin-top-md">
	<h4>
		If the specific role is not shown, that role does not have access to this workflow. Please check <a
			[routerLink]="'/accounts/permissions'">permissions</a>.
	</h4>
	<h4>If the specific role is not enabled, that role does not have access to the "FROM" state.</h4>
	<mat-table id="permission-table" [dataSource]="tableDataSources[0]" class="table-responsive mat-elevation-z1"
		matSort>

		<ng-container matColumnDef="NAME">
			<mat-header-cell *matHeaderCellDef>From/To -></mat-header-cell>
			<mat-cell *matCellDef="let element">
				<div>{{element.NAME}}</div>
			</mat-cell>
		</ng-container>

		<ng-container [matColumnDef]="workflowStateType.NAME!" *ngFor="let workflowStateType of workflowStateTypes">
			<mat-header-cell *matHeaderCellDef class="row">
				{{workflowStateType.NAME}} </mat-header-cell>
			<mat-cell *matCellDef="let element" class="row"
				[matTooltip]="element.NAME! + ' => ' + workflowStateType.NAME!" matTooltipPosition="above"
				matTooltipClass="multiline-tooltip" [matTooltipDisabled]="element.ID === workflowStateType.ID">
				<div *ngFor="let role of element[workflowStateType.ID!].ROLES; let i = index" class=""
					[hidden]="element.ID === workflowStateType.ID">
					<mat-checkbox [disabled]="!hasPermission || !role.hasPermission" [(ngModel)]="role.hasTransition"
						color="primary"
						(change)="toggleTransition($event, element, i, element[workflowStateType.ID!].WORKFLOW_STATE_TYPES_ID_FROM, element[workflowStateType.ID!].WORKFLOW_STATE_TYPES_ID_TO, role.ID)">
						{{role.NAME}}
					</mat-checkbox>


					<button mat-icon-button [hidden]="!role.hasTransition"
						[ngClass]="{'cursor-pointer': role.hasTransition}"
						[color]="(hasTransitionProperties(role) ? 'primary' : '')"
						(click)="role.hasTransition? openStudentDialog(element, workflowStateType, role) : null"
						matTooltip="Transition Properties">
						<mat-icon>flag</mat-icon>
					</button>
				</div>
			</mat-cell>
		</ng-container>

		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
	</mat-table>
</div>